<section>
  <h6 class="uk-flex uk-flex-middle"><span class="material-symbols-outlined uk-margin-small-right">settings</span>Field settings</h6>
  <ul data-uk-accordion="multiple: true">
    @if (options().length) {
      <li class="uk-open">
        <a class="uk-accordion-title uk-text-normal uk-text-default" href>Type &amp; behaviour</a>
        <div class="uk-accordion-content">
          <div class="uk-margin">
            <label for="fieldType" class="uk-text-muted uk-margin-small-bottom">Field type</label>
            <select id="fieldType" type="select" class="uk-select" [ngModel]="$safeNavigationMigration(fbService.currentField()?.typeInfo?.type)"
                    (ngModelChange)="fbService.setFieldType($event)">
              @for (option of options(); track option.value +''+ $index) {
                <option value="{{option.value}}">{{option.label}}</option>
              }
            </select>
          </div>
          @if (!['select', 'radio', 'checkbox'].includes(fbService.currentField()?.typeInfo?.type || '')) {
            <div class="uk-margin">
              <label for="placeholder" class="uk-text-muted uk-margin-small-bottom">Placeholder</label>
              <input id="placeholder" type="text" class="uk-input" [ngModel]="$safeNavigationMigration(fbService.currentField()?.form?.placeholder)"
                     (ngModelChange)="fbService.setFieldPlaceholder($event)">
            </div>
          }
          <div class="uk-margin uk-flex uk-flex-middle uk-flex-between">
            <span>
              <span class="uk-text-bold uk-display-block">Mandatory</span>
              <span class="uk-text-muted uk-text-small">Respondents must answer.</span>
            </span>
            <input id="fieldMandatory" class="uk-checkbox" type="checkbox" [(ngModel)]="fbService.currentField()!.form.mandatory">
          </div>
          @if (fbService.currentField()?.typeInfo?.type !== 'radio') {
            <div class="uk-margin uk-flex uk-flex-middle uk-flex-between">
              <span>
                <span class="uk-text-bold uk-display-block">Allow multiplicity</span>
                <span class="uk-text-muted uk-text-small">Let respondents repeat this answer.</span>
              </span>
              <input id="multiplicity" class="uk-checkbox" type="checkbox" [(ngModel)]="fbService.currentField()!.typeInfo.multiplicity">
            </div>
          }
        </div>
      </li>
    }
    <li class="uk-open">
      <a class="uk-accordion-title uk-text-normal uk-text-default" href>Label</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="label" class="uk-text-muted uk-margin-small-bottom">Text</label>
          <div class="uk-form-controls">
            <app-rich-text-editor id="label" [ngModel]="$safeNavigationMigration(fbService.currentField()?.label?.text)"
                      (ngModelChange)="fbService.setFieldLabel($event)" placeholder="Field label">
            </app-rich-text-editor>
          </div>
        </div>
        <div class="uk-margin">
          <label for="labelCSS" class="uk-text-muted uk-margin-small-bottom">CSS classes</label>
          <input id="labelCSS" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.label.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="labelStyles" class="uk-text-muted uk-margin-small-bottom">Styles</label>
          <input id="labelStyles" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.label.style">
        </div>
      </div>
    </li>
    <li>
      <a class="uk-accordion-title uk-text-normal uk-text-default" href>Description</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="descriptionText" class="uk-text-muted uk-margin-small-bottom">Text</label>
          <div class="uk-form-controls">
            <app-rich-text-editor id="descriptionText"
                      [(ngModel)]="fbService.currentField()!.form.description.text"
                      placeholder="Give a description for the field">
            </app-rich-text-editor>
          </div>
        </div>
        <div class="uk-margin uk-text-muted">
          <input id="descriptionShowMore" class="uk-checkbox" type="checkbox"
                 [(ngModel)]="fbService.currentField()!.form.description.showLess">
          <label for="descriptionShowMore" class="uk-checkbox-label uk-margin-small-left">Show less</label>
        </div>
        <div class="uk-margin">
          <label for="descriptionCSS" class="uk-text-muted uk-margin-small-bottom">CSS classes</label>
          <input id="descriptionCSS" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.form.description.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="descriptionStyles" class="uk-text-muted uk-margin-small-bottom">Styles</label>
          <input id="descriptionStyles" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.form.description.style">
        </div>
      </div>
    </li>
    <li>
      <a class="uk-accordion-title uk-text-normal uk-text-default" href>Suggestion</a>
      <div class="uk-accordion-content">
        <div class="uk-margin">
          <label for="suggestionText" class="uk-text-muted uk-margin-small-bottom">Text</label>
          <div class="uk-form-controls">
            <app-rich-text-editor id="suggestionText"
                      [(ngModel)]="fbService.currentField()!.form.suggestion.text"
                      placeholder="Give a short suggestion for the field">
            </app-rich-text-editor>
          </div>
        </div>
        <div class="uk-margin">
          <label for="suggestionCSS" class="uk-text-muted uk-margin-small-bottom">CSS classes</label>
          <input id="suggestionCSS" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.form.suggestion.cssClasses">
        </div>
        <div class="uk-margin">
          <label for="suggestionStyles" class="uk-text-muted uk-margin-small-bottom">Styles</label>
          <input id="suggestionStyles" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.form.suggestion.style">
        </div>
      </div>
    </li>
    <li>
      <a class="uk-accordion-title uk-text-normal uk-text-default">Advanced</a>
      <div class="uk-accordion-content ">
        <div class="uk-text-muted uk-text-bold">
          <input id="dependsOn" class="uk-checkbox" type="checkbox" [checked]="enableList()" (change)="enableFieldList($event)">
          <label for="dependsOn" class="uk-checkbox-label uk-margin-small-left">This field depends on an other field</label>
          @if (enableList()) {
            <p class="uk-text-muted uk-margin-small">Select the field</p>
            <ng-select id="dependsOnSelect" class="uk-margin-small-bottom"
                       [items]="dependsOnList()"
                       [(ngModel)]="dependsOnField"
                       (change)="setDependsOn($event)">
              <ng-template ng-label-tmp let-item="item">
                {{ (stripHtml(item.label.text) || 'Untitled field') +' (id: '+item.id+')' }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ (stripHtml(item.label.text) || 'Untitled field') +' (id: '+item.id+')' }}
              </ng-template>
            </ng-select>
          }
          @if (fbService.currentField()?.form?.dependsOn?.id) {
            <div>
              <input id="anyValue" name="dependsOnValue" class="uk-radio uk-margin-xsmall-right" type="radio"
                     value="anyValue" [(ngModel)]="dependsOnSelection" (change)="initDependsOnValue($event)">
              <label for="anyValue" class="uk-radio-label">Enable field for any value.</label>
            </div>
            <div class="uk-margin-small-bottom">
              <input id="specificValue" name="dependsOnValue" class="uk-radio uk-margin-xsmall-right" type="radio"
                     value="specificValue" [(ngModel)]="dependsOnSelection" (change)="initDependsOnValue($event)">
              <label for="specificValue" class="uk-radio-label">Enable field for specific value(s).</label>
            </div>
            @if (dependsOnSelection === 'specificValue') {
              <ul class="uk-list uk-list-disc uk-margin-small-top uk-flex uk-flex-column">
                @for (value of fbService.currentField()?.form?.dependsOn?.value; track value) {
                  <li>
                    <div class="uk-flex uk-flex-middle">
                      {{value}}<a class="material-symbols-outlined uk-text-decoration-none" style="font-size: 22px"
                                  (click)="removeDependsOnValue(value)">delete</a>
                    </div>
                  </li>
                }
              </ul>
              <div class="uk-margin-small uk-flex uk-flex-middle">
                <input id="dependsOnValue" type="text" class="uk-input uk-width-expand" [(ngModel)]="dependsOnValue">
                <button class="uk-button uk-button-default" type="button" (click)="addDependsOnValue()">Add</button>
              </div>
            }
          }
        </div>
        @if (fbService.currentField()?.typeInfo?.type === 'composite') {
          <div class="uk-text-muted uk-text-bold">
            <input id="showBorder" class="uk-checkbox" type="checkbox" [(ngModel)]="fbService.currentField()!.form.display.hasBorder">
            <label for="showBorder" class="uk-checkbox-label uk-margin-small-left">Show border</label>
          </div>
        }
        <div class="uk-text-muted uk-text-bold">
          <input id="hidden" class="uk-checkbox" type="checkbox" [ngModel]="!fbService.currentField()?.form?.display?.visible"
                 (ngModelChange)="setVisibility($event)">
          <label for="hidden" class="uk-checkbox-label uk-margin-small-left">Hide field</label>
        </div>
        <div class="uk-margin">
          <div class="uk-flex uk-flex-middle">
            <label for="fieldName" class="uk-text-muted uk-margin-small-bottom uk-flex uk-flex-middle">
              JSON model field name
              <span class="material-symbols-sharp" data-uk-tooltip="Define the property name in the answer JSON object. If none provided the field id will be used instead. (A unique name is recommended).">info</span>
            </label>
          </div>
          <input id="fieldName" type="text" class="uk-input" [(ngModel)]="fbService.currentField()!.name">
        </div>
      </div>
    </li>
  </ul>

</section>
